export default {"src":"/_next/static/media/joinBottomFrame.27da7785.svg","height":79,"width":1920,"blurWidth":0,"blurHeight":0};